export default {
    getEnums: state => state.enums,
    getUser: state => state.user,
    getToken: state => state.token,
    getNotification: state => state.notification,
    getAdminStatistics: state => state.statistics,
    getSocket: state => state.socket,
    getLocalisationKeys: state => state.localisation,
    getLanguage: state => state.language,
}